import { useCallback } from 'react'
import { Button } from '@genie-fintech/ui/components'
import { title } from '@genie-fintech/ui/style/typography'

import { container, innerContainer } from './styles.css'

const TenantEmpty = () => {
  const onClick = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <article className={container}>
      <article className={innerContainer}>
        <p className={title.one}>Oops! Idp list is empty.</p>

        <article>
          <Button onClick={onClick}>Reload</Button>
        </article>
      </article>
    </article>
  )
}

export default TenantEmpty
